import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            fullname:'',//用户姓名
            usertype:'',//用户类型
            organizationid:'',//所属组织
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询
        selectUser(context, payload) {
            payload.type = 'usercenter/selectUser'
            return D.select({
                ...payload
            })

        },
        //用户类型
        changeUser(context, payload) {
            payload.type = 'usercenter/changeUser'
            return D.del({
                ...payload
            })
        },
        //编辑，查看
        detailUser(context, payload) {
            let apikey = 'usercenter/detailUser'
            return D.detail({
                apikey,
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
  
        },
        getEmptyUser(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {
                        organization:[],
                        role:[],
                        system:[],
                    }
                }
            })
        },
        selectOrgList(context, payload){
            return D.select({
                ...payload
            })
        },
        selectRoleList(context, payload){
            return D.select({
                ...payload
            })
        },
        selectSystemList(context, payload){
            return D.select({
                ...payload
            })
        },
        // 更新任务
        updateAddUser(context, payload) {
            return D.edit({
                ...payload
            })
        },
        addEditMenu(context, payload) {
            return D.edit({
                ...payload
            })
        },
        deleteMenu(context, payload) {
            return D.del({
                ...payload
            })
        },
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        fullname:'',//用户姓名
                        usertype:'',//用户类型
                        organizationid:''//所属组织
                    }
                }
            })
        },
    }
}